import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as analytics from '../../services/analytics';
import './Passport360EnrollmentPlanTypeView.css';

const propTypes = {
  client: PropTypes.object,
  updatePlansFilter: PropTypes.func,
  onSubmit: PropTypes.func,
};

class Passport360EnrollmentPlanTypeView extends PureComponent {
  componentDidMount() {
    analytics.page('Passport 360 - Enrollment Plan Type');
  }

  handleUpdate = (e) => {
    this.props.updatePlansFilter({
      planType: e.target.value,
    });
  };

  get title() {
    const { actor, client } = this.props;
    if (actor === 'broker') {
      return `What type of coverage does ${client.person.first_name} need?`;
    } else {
      return 'What type of coverage do you need?';
    }
  }

  render() {
    const { client, plansFilter, onSubmit } = this.props;

    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            <h3 className="text-center semi-bold">{this.title}</h3>

            <div className="Passport360EnrollmentPlanTypeView-clientDetails card m-t-20">
              <div className="card-block">
                <div className="radio radio-success">
                  <input
                    id="radioIndividual"
                    type="radio"
                    name="planType"
                    value="individual"
                    checked={plansFilter.planType === 'individual'}
                    onChange={this.handleUpdate}
                  />
                  <label
                    className="Passport360EnrollmentPlanTypeView-radio"
                    htmlFor="radioIndividual"
                  >
                    <strong className="Passport360EnrollmentPlanTypeView-radio-label">
                      Individual
                    </strong>
                    <p className="Passport360EnrollmentPlanTypeView-radio-info">
                      Covers {client.person.first_name} only
                    </p>
                  </label>
                </div>
                <div className="radio radio-success">
                  <input
                    id="radioFamily"
                    type="radio"
                    name="planType"
                    value="family"
                    checked={plansFilter.planType === 'family'}
                    onChange={this.handleUpdate}
                  />
                  <label
                    className="Passport360EnrollmentPlanTypeView-radio"
                    htmlFor="radioFamily"
                  >
                    <strong className="Passport360EnrollmentPlanTypeView-radio-label">
                      Family
                    </strong>
                    <p className="Passport360EnrollmentPlanTypeView-radio-info">
                      Covers dependents
                    </p>
                  </label>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <button
                className="btn btn-lg btn-complete"
                disabled={!plansFilter.planType}
                onClick={onSubmit}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Passport360EnrollmentPlanTypeView.propTypes = propTypes;

export default Passport360EnrollmentPlanTypeView;
